var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconAlone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.029,
    height: 16.027,
    viewBox: "0 0 16.029 16.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13401",
    "data-name": "Group 13401",
    transform: "translate(738.003 3041.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7538",
    "data-name": "Path 7538",
    d: "M-728.555-3029.563a6.125,6.125,0,0,1-1.6.634,6.208,6.208,0,0,1-5.47-1.2,5.95,5.95,0,0,1-2.266-3.753,6.175,6.175,0,0,1,2.188-6.07,5.79,5.79,0,0,1,3.1-1.379,6.207,6.207,0,0,1,5.914,2.369,5.94,5.94,0,0,1,1.259,2.871,6.236,6.236,0,0,1-.682,4.03.136.136,0,0,0,.028.195c1.18,1.176,2.355,2.357,3.537,3.53a1.763,1.763,0,0,1,.576,1.269,1.7,1.7,0,0,1-1.014,1.559,1.674,1.674,0,0,1-1.874-.36c-.709-.7-1.411-1.409-2.116-2.115Zm-3.133-.865a4.641,4.641,0,0,0,4.648-4.62,4.632,4.632,0,0,0-4.589-4.663,4.632,4.632,0,0,0-4.69,4.6A4.641,4.641,0,0,0-731.687-3030.428Z",
    transform: "translate(0 0)",
    fill: "#9dacbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7539",
    "data-name": "Path 7539",
    d: "M-613.688-2920.9a.873.873,0,0,1,.92.773.856.856,0,0,1-.744.92,3.116,3.116,0,0,0-.6.087,1.659,1.659,0,0,0-1.183,1.565.866.866,0,0,1-.588.846.849.849,0,0,1-1.107-.815,3.38,3.38,0,0,1,2.245-3.17,3.766,3.766,0,0,1,.526-.141C-614.043-2920.871-613.865-2920.881-613.688-2920.9Z",
    transform: "translate(-118.069 -117.556)",
    fill: "#9dacbd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconAlone);
export default __webpack_public_path__ + "static/media/searchIconAlone.c901fc4ad1c118ee9567c9ded421e403.svg";
export { ForwardRef as ReactComponent };